// Centralized TanStack Query key factory
export const queryKeys = {
  // Auth
  authUser: ['authUser'] as const,

  // Dashboard
  currentUser: ['currentUser'] as const,
  dashboardStats: ['dashboardStats'] as const,

  // Customers
  customers: (search?: string, limit?: number, offset?: number, noEmail?: boolean) => ['customers', { search, limit, offset, noEmail }] as const,
  customer: (customerId: number) => ['customer', customerId] as const,
  customerPrices: (customerId: number) => ['customerPrices', customerId] as const,
  customerAccount: (customerId: number) => ['customerAccount', customerId] as const,
  customerAccounts: ['customerAccounts'] as const,

  // Vehicles
  vehicles: (customerId: number) => ['vehicles', customerId] as const,

  // Tire Sets
  tireSets: (filters?: { filter?: string; mounted_filter?: string; season_filter?: string; search?: string; limit?: number; offset?: number }) =>
    ['tireSets', filters] as const,
  tireSetPhotos: (tireSetId: number | null) => ['tireSetPhotos', tireSetId] as const,
  changelog: ['changelog'] as const,

  // Tenants

  // Demo-Reifen
  demoTires: (params?: object) => ['demoTires', params] as const,
  demoTire: (demoTireId: number) => ['demoTire', demoTireId] as const,
  demoTireBrands: (activeOnly: boolean) => ['demoTireBrands', activeOnly] as const,
  demoTireAvailability: (sizes: string[]) => ['demoTireAvailability', sizes] as const,

  // Änderungswünsche (Kundenstammdaten)
  customerChangeRequests: (status: string) => ['customerChangeRequests', status] as const,
  pendingChangeRequestCount: ['pendingChangeRequestCount'] as const,

  // Permissions
  myPermissions: ['myPermissions'] as const,
  userPermissions: (userId: string) => ['userPermissions', userId] as const,
};
